import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=14fb4f18&scoped=true&"
import script from "./PageTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=14fb4f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb4f18",
  null
  
)

export default component.exports